import React, { useEffect, useState } from 'react'

import Svg, {
  Circle,
  Defs,
  Image,
  Path,
  Pattern,
  Text,
  Stop,
  LinearGradient,
} from 'react-native-svg'
import { VictoryPie } from 'victory-native'
import { Platform, View } from 'react-native'
import { color } from '../../theme'

const initData = [
  { y: 0, fill: 'none' },
  { y: 100, fill: 'none' },
]

export const RecallWheel = (props: any) => {
  const {
    value,
    showPercentage,
    variant,
    showGradient,
    style,
    id,
    icon,
    iconColour,
    circleColour,
    textColor,
    hideIcon,
    strokeColor,
  } = props

  const fillValue = Math.round((value ?? 0) * 100)

  let fillColor = circleColour || color.white

  const trivieGradientId = `TrivieGradient_RW_${id}`
  const trivieGradientImgId = `TrivieGradientImg_RW_${id}`
  const flubberId = `Flubber_RW_${id}`
  const flubberImgId = `FlubberImg_RW_${id}`

  if (showGradient) {
    fillColor = Platform.OS === 'ios' ? `url(#${trivieGradientImgId})` : `url(#${trivieGradientId})`
  }

  let size = 20

  if (variant === 'small') {
    size = 22
  } else if (variant === 'medium-small') {
    size = 28
  } else if (variant === 'medium') {
    size = 36
  } else if (variant === 'medium-large') {
    size = 42
  } else if (variant === 'large') {
    size = 60
  } else if (variant === 'extraLarge') {
    size = 80
  }

  const [finalData, setFinalData] = useState(initData)

  useEffect(() => {
    const timer = setTimeout(() => {
      setFinalData([
        { y: fillValue, fill: fillColor },
        { y: 100 - fillValue, fill: 'none' },
      ])
    }, 1000)
    return () => clearTimeout(timer)
  }, [])

  const renderIcon = (icon: string) => {
    switch (icon) {
      case 'lock':
        return (
          <Path
            d="M22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11ZM1.98 11C1.98 15.9816 6.01839 20.02 11 20.02C15.9816 20.02 20.02 15.9816 20.02 11C20.02 6.01839 15.9816 1.98 11 1.98C6.01839 1.98 1.98 6.01839 1.98 11Z"
            fill="black"
            fill-opacity="0.2"
          />
        )
      case 'gradient_check':
        return (
          <>
            <Path
              transform="translate(11, 11) scale(1.2, 1.2)"
              d="M11.4009 21.4675L6.90275 16.9694C6.66056 16.7267 6.33175 16.5902 5.98886 16.5902C5.64596 16.5902 5.31716 16.7267 5.07497 16.9694C4.56941 17.4749 4.56941 18.2916 5.07497 18.7972L10.4935 24.2157C10.999 24.7212 11.8157 24.7212 12.3213 24.2157L26.0361 10.5009C26.5416 9.99532 26.5416 9.17865 26.0361 8.67309C25.7939 8.43036 25.4651 8.29395 25.1222 8.29395C24.7793 8.29395 24.4505 8.43036 24.2083 8.67309L11.4009 21.4675Z"
              fill="url(#paint0_linear_1099_54607)"
              stroke="url(#paint1_linear_1099_54607)"
              stroke-width="0.797926"
            />
            <Defs>
              <LinearGradient
                id="paint0_linear_1099_54607"
                x1="8.08712"
                y1="24.0795"
                x2="25.9642"
                y2="7.79911"
                gradientUnits="userSpaceOnUse"
              >
                <Stop stop-color="#FF00FF" />
                <Stop offset="0.46" stop-color="#9116F9" />
                <Stop offset="1" stop-color="#3199FF" />
              </LinearGradient>
              <LinearGradient
                id="paint1_linear_1099_54607"
                x1="8.08712"
                y1="24.0795"
                x2="25.9642"
                y2="7.79911"
                gradientUnits="userSpaceOnUse"
              >
                <Stop stop-color="#FF00FF" />
                <Stop offset="0.46" stop-color="#9116F9" />
                <Stop offset="1" stop-color="#3199FF" />
              </LinearGradient>
            </Defs>
          </>
        )

      case 'path':
        return (
          <Path
            transform="translate(14, 14) scale(1.8, 1.8)"
            fill={iconColour || color.white}
            d="M15.4614 3.48205C15.4614 3.97265 15.3149 4.40043 15.0217 4.76538C14.7285 5.13034 14.3725 5.36068 13.9537 5.45641V9.27949C13.9537 10.0692 13.6935 10.7244 13.173 11.2449C12.6525 11.7654 11.9973 12.0256 11.2076 12.0256C10.4178 12.0256 9.76272 11.7654 9.24221 11.2449C8.72169 10.7244 8.46144 10.0692 8.46144 9.27949V7.89744C8.46144 7.40684 8.30588 7.00598 7.99477 6.69487C7.68366 6.38376 7.28281 6.2282 6.79221 6.2282C6.30161 6.2282 5.90075 6.38376 5.58964 6.69487C5.27853 7.00598 5.12298 7.40684 5.12298 7.89744V11.7744C5.54178 11.8821 5.89776 12.1154 6.19092 12.4744C6.48409 12.8333 6.63067 13.2581 6.63067 13.7487C6.63067 14.3231 6.43323 14.8077 6.03836 15.2026C5.64349 15.5974 5.15887 15.7949 4.58451 15.7949C4.01016 15.7949 3.52554 15.5974 3.13067 15.2026C2.7358 14.8077 2.53836 14.3231 2.53836 13.7487C2.53836 13.2581 2.68494 12.8333 2.9781 12.4744C3.27127 12.1154 3.62725 11.8821 4.04605 11.7744V7.89744C4.04605 7.10769 4.30631 6.45256 4.82682 5.93205C5.34734 5.41154 6.00246 5.15128 6.79221 5.15128C7.58195 5.15128 8.23708 5.41154 8.75759 5.93205C9.2781 6.45256 9.53836 7.10769 9.53836 7.89744V9.27949C9.53836 9.77009 9.69392 10.1709 10.005 10.4821C10.3161 10.7932 10.717 10.9487 11.2076 10.9487C11.6982 10.9487 12.099 10.7932 12.4102 10.4821C12.7213 10.1709 12.8768 9.77009 12.8768 9.27949V5.45641C12.458 5.34872 12.102 5.11539 11.8089 4.75641C11.5157 4.39744 11.3691 3.97265 11.3691 3.48205C11.3691 2.90769 11.5666 2.42308 11.9614 2.0282C12.3563 1.63333 12.8409 1.4359 13.4153 1.4359C13.9896 1.4359 14.4743 1.63333 14.8691 2.0282C15.264 2.42308 15.4614 2.90769 15.4614 3.48205ZM5.55375 13.7487C5.55375 13.4735 5.46101 13.2432 5.27554 13.0577C5.09007 12.8722 4.85973 12.7795 4.58451 12.7795C4.3093 12.7795 4.07896 12.8722 3.89349 13.0577C3.70802 13.2432 3.61528 13.4735 3.61528 13.7487C3.61528 14.0239 3.70802 14.2543 3.89349 14.4397C4.07896 14.6252 4.3093 14.7179 4.58451 14.7179C4.85973 14.7179 5.09007 14.6252 5.27554 14.4397C5.46101 14.2543 5.55375 14.0239 5.55375 13.7487Z"
          />
        )
      case 'check':
        return (
          <Path
            transform="translate(11, 11) scale(1.6, 1.6)"
            fill={iconColour || color.white}
            d="M8.795 15.875l-3.47-3.47a.996.996 0 10-1.41 1.41l4.18 4.18c.39.39 1.02.39 1.41 0l10.58-10.58a.996.996 0 10-1.41-1.41l-9.88 9.87z"
          />
        )
      case 'play':
        return (
          <Path
            transform="translate(22, 17) scale(2.5,2.5)"
            d="M0.333336 1.54651V8.45318C0.333336 8.97984 0.913336 9.29984 1.36 9.01318L6.78667 5.55984C7.2 5.29984 7.2 4.69984 6.78667 4.43318L1.36 0.986509C0.913336 0.699843 0.333336 1.01984 0.333336 1.54651Z"
            fill={iconColour || color.white}
          />
        )
      default:
        return (
          <Path
            transform="translate(11, 11) scale(1.6, 1.6)"
            fill={iconColour || color.white}
            d="M10.67 21c-.35 0-.62-.31-.57-.66L11 14H7.5c-.88 0-.33-.75-.31-.78 1.26-2.23 3.15-5.53 5.65-9.93.1-.18.3-.29.5-.29.35 0 .62.31.57.66l-.9 6.34h3.51c.4 0 .62.19.4.66-3.29 5.74-5.2 9.09-5.75 10.05-.1.18-.29.29-.5.29z"
          />
        )
    }
  }

  return (
    <View style={{ width: size, height: size, ...style }}>
      <Svg viewBox="0 0 60 60" height={size} width={size}>
        <Defs>
          <LinearGradient id={trivieGradientId}>
            <Stop offset="10%" stopColor="#3199FF" />
            <Stop offset="60%" stopColor="#9116F9" />
            <Stop offset="100%" stopColor="#FF00FF" />
          </LinearGradient>

          <LinearGradient id={flubberId}>
            <Stop offset="1%" stopColor="#7FDD53" />
            <Stop offset="86%" stopColor="#2FEA9B" />
          </LinearGradient>
        </Defs>
        <Defs>
          <Pattern
            id={trivieGradientImgId}
            patternUnits="userSpaceOnUse"
            width={size}
            height={size}
          >
            <Image href={require('./trivie-gradient.png')} x={0} y={0} width={size} height={size} />
          </Pattern>
          <Pattern id={flubberImgId} patternUnits="userSpaceOnUse" width={size} height={size}>
            <Image
              href={require('./flubber-gradient.png')}
              x={0}
              y={0}
              width={size}
              height={size}
            />
          </Pattern>
        </Defs>

        {showPercentage ? (
          <Text
            x={31}
            y={36}
            textAnchor="middle"
            fill={textColor ? textColor : color.black}
            fontFamily="Inter"
            fontSize={fillValue === 100 ? 14 : 16}
            fontWeight={600}
            fontStyle="normal"
            letterSpacing={-0.2}
          >{`${String(fillValue)}%`}</Text>
        ) : !hideIcon ? (
          renderIcon(icon)
        ) : null}

        <Circle
          cx={30}
          cy={30}
          r={28}
          stroke={strokeColor ? strokeColor : variant === 'large' ? color.shade10 : color.tint10}
          strokeWidth={5}
          fill="none"
        />

        <VictoryPie
          labelComponent={<></>}
          standalone={false}
          height={60}
          width={60}
          radius={30}
          origin={{ x: 30, y: 30 }}
          innerRadius={25}
          cornerRadius={5}
          animate={{ easing: 'sin', duration: 2000 }}
          data={finalData}
          style={{
            labels: { display: 'none' },
            data: {
              fill: ({ datum }) => datum.fill,
              opacity: ({ datum }) => datum.opacity,
            },
          }}
        />
      </Svg>
    </View>
  )
}
